import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { OrganizationDbService } from "@shared/database/organization-db-service";
import { DialogService } from "primeng/dynamicdialog";
import { OrganizationDialogComponent } from "../organization-dialog/organization-dialog.component";
// import { CategoryDialogComponent } from "../../private/pages/categories/category-dialog/category-dialog.component";

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  constructor(
    private dialogService: DialogService,
    private organizationDbService: OrganizationDbService,
    private translateService: TranslateService,
    ){

  }
  add(data){
    return this.organizationDbService.upsert(data);
  }

  addDialog(){
    const ref = this.dialogService.open(OrganizationDialogComponent,{
      data:{
      },
      header: this.translateService.instant('LABEL.ORGANIZATION'),
      // width: '1000px',
      // style:{ 'min-height': '600px'}
    })
    ref.onClose.subscribe((resp: any) => {
      if (resp) {
        // this.router.navigate([resp.id], { relativeTo: this.route });
        //   this.messageService.add({severity:'info', summary: 'Supplier added', detail:'' });
      }
    });
  }
}
